import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Projects.module.css';
import { projects } from '../data/portfolio';

const iconColors = {
  triptailor:        { bg: '#e6ede6', stroke: '#2c4a2e' },
  nova:              { bg: '#f0e8e0', stroke: '#7a3b1e' },
  'firebase-research': { bg: '#eaeaf0', stroke: '#4a4a8a' },
  'ad-sync':         { bg: '#e8f0e8', stroke: '#2a5a2a' },
};

function ProjectIcon({ id }) {
  const c = iconColors[id] || { bg: '#ede8e0', stroke: '#5a5248' };
  return (
    <div className={styles.icon} style={{ background: c.bg }}>
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <rect x="2" y="4" width="14" height="11" rx="2" stroke={c.stroke} strokeWidth="1.3"/>
        <path d="M6 4V3a2 2 0 014 0v1" stroke={c.stroke} strokeWidth="1.2"/>
        <path d="M6 9h6M6 12h4" stroke={c.stroke} strokeWidth="1.1" strokeLinecap="round"/>
      </svg>
    </div>
  );
}

export default function Projects() {
  return (
    <div className={styles.grid}>
      {projects.map((p) => (
        <Link
          key={p.id}
          to={`/project/${p.id}`}
          className={`${styles.projStack} fade-in`}
        >
          <div className={styles.card}>
            <div className={styles.header}>
              <ProjectIcon id={p.id} />
              <span className={`status-badge status-${p.status}`}>{p.statusLabel}</span>
            </div>
            <div className={styles.name}>{p.name}</div>
            <div className={styles.subtitle}>{p.subtitle}</div>
            <p className={styles.desc}>{p.desc}</p>
            <div className={styles.tags}>
              {p.tags.slice(0, 4).map(t => (
                <span key={t} className={styles.ptag}>{t}</span>
              ))}
              {p.tags.length > 4 && (
                <span className={styles.ptag}>+{p.tags.length - 4}</span>
              )}
            </div>
            <div className={styles.viewHint}>
              <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
                <path d="M2 9L9 2M9 2H4M9 2v5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              View case study
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}
